export default {
    INTRO: "intro",
    THEME: "theme",
    LINEUP: "lineup",
    IDEAS: "ideas",
    PARTNERS: "partners",
    INFO: "info",
    TICKETS: "tickets",
}







